import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { CalendarService } from 'src/app/Service/Calendar/Calendar.service';

@Component({
  selector: 'app-CalendarForm',
  templateUrl: './CalendarForm.component.html',
  styleUrls: ['./CalendarForm.component.scss']
})
export class CalendarFormComponent implements OnInit {

  constructor(
    private Calendar_Service:CalendarService,
    private Nav_Service:NavService,
    private Alertify_Service:AlertifyService
  ) { }

  ngOnInit() {

    this.AddNewCalendar=new FormGroup({
      id :new FormControl(),
      Title:new FormControl(null,Validators.required),
    })


    this.Nav_Service.CheckValidPage(1124).subscribe(
      data=>{

      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }


  //#region  Form Add

  AddNewCalendar:FormGroup;

  get_Form_Title(){
    return this.AddNewCalendar.get('Title') as FormControl;
  }

  //#endregion

  InProccessing:boolean=false

  SubmitAddNewCalendar(StartDate){

    this.InProccessing=true
    this.Calendar_Service.Add(StartDate,this.get_Form_Title().value).subscribe(
      data=>{
        this.InProccessing=false
        if(data.id==-2){
          this.Alertify_Service.ErrorMessage("تاریخ انتخاب شده ، در لیست وجود دارد")
        }
        else{
          this.AddNewCalendar.reset()
          this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
        }
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }



}
